import { apiSlice } from '@client/api';

import { selectSessionUser } from '../../redux';
import { useAppSelector } from '../useAppSelector';

export const useSession = () => {
  const sessionUser = useAppSelector(selectSessionUser);
  const { isFetching } = apiSlice.endpoints.getAuthSessionUser.useQueryState();

  return { sessionPerson: sessionUser?.person ?? null, sessionUser, isFetching };
};
